<template>
  <b-container fluid class="competition-frame">
    <b-row>
      <b-col sm="4" class="text-left">
        <h1>Pályázatok</h1>
      </b-col>
      <b-col sm="4">
        <b-form-group label-for="filter-input">
          <b-form-input
            @update="onFilterChange('name', $event)"
            id="filter-name-input"
            :value="competitionNameFilter"
            type="search"
            placeholder="Keresés"
            class="search-box"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="2" class="text-left mt-2 pl-0">
        <b-link v-b-modal.filter-modal class="filter-link">Szűrők</b-link>
        <b-modal id="filter-modal" title="Szűrők" size="xl" hide-header hide-footer>
          <competition-list-filter
            :filters="competitionFilters"
            :onFilter="onFilter"
            :closeModal="() => $bvModal.hide('filter-modal')"
          />
        </b-modal>
      </b-col>
      <b-col sm="2" class="pr-0">
        <b-button class="competition-button" @click="navigateToCreate()" variant="primary"
          >Új termék rögzítése</b-button
        >
      </b-col>
    </b-row>
    <div class="d-flex flex-row flex-wrap text-left justify-content-between mt-3 mb-5">
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.SHOW_ALL) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.SHOW_ALL)"
      >
        Összes
      </div>
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.IN_PROGRESS) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.IN_PROGRESS)"
      >
        Piszkozat
      </div>
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.UNDER_APPROVAL) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.UNDER_APPROVAL)"
      >
        Jóváhagyás alatt
      </div>
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.APPROVED) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.APPROVED)"
      >
        Jóváhagyott
      </div>
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.ACTIVE) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.ACTIVE)"
      >
        Aktív
      </div>
      <div
        class="filter-tab"
        v-bind:class="{ selected: selectedStatusFilter(competitionStatusFilterTypes.INACTIVE) }"
        @click="onStatusFilterClick(competitionStatusFilterTypes.INACTIVE)"
      >
        Lejárt
      </div>
    </div>

    <!-- Main table element -->
    <b-table
      :sort-compare="mySortCompare"
      :items="competitionList"
      :fields="fields"
      :current-page="competitionCurrentPage"
      per-page="0"
      :filter-included-fields="['name', 'createdDate', 'modifiedDate']"
    >
      <template #cell(name)="data"
        ><b-link :to="{ path: '/competitions/details', query: { id: data.item._id } }">{{ data.item.name }}</b-link>
      </template>
      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getReadableCompetitionStatus } from '../../constants/competitionStatus'
import { getReadableCompetitionType } from '../../constants/competitionTypes'
import { competitionStatusFilterTypes } from '../../constants/competitonStatusFilterTypes'
import CompetitionListFilter from './components/CompetitionListFilter.vue'
export default {
  components: { CompetitionListFilter },
  beforeMount: function() {
    this.$store.dispatch('getCompetitionList')
  },
  created: function() {
    this.$store.commit('setAllFiltersFromRouteQuery')
  },
  data() {
    return {
      competitionStatusFilterTypes,
      fields: [
        {
          key: 'code',
          label: 'Kód',
          sortable: true
        },
        {
          key: 'name',
          label: 'Pályázat neve',
          sortable: true
        },
        {
          key: 'type',
          label: 'Típus',
          sortable: true,
          formatter: type => getReadableCompetitionType(type)
        },
        {
          key: 'createdBy.fullName',
          label: 'Rögzítette',
          sortable: true
        },
        {
          key: 'modifiedDate',
          label: 'Utoljára módosítva',
          sortable: true,
          formatter: date => this.formatDate(date)
        },
        {
          key: 'status',
          label: 'Állapot',
          sortable: true,
          formatter: status => getReadableCompetitionStatus(status)
        }
      ],
      filterOn: []
    }
  },
  computed: {
    perPage: () => process.env.VUE_APP_COMPETITIONS_PER_PAGE,
    ...mapGetters([
      'competitionFilters',
      'competitionList',
      'competitionNameFilter',
      'competitionListTotalCount',
      'competitionCurrentPage',
      'competitionStatusFilter'
    ]),
    filterCount: function() {
      let result = 0
      this.competitionFilters.activeDate && result++
      this.competitionFilters.showApplication && result++
      this.competitionFilters.showCredit && result++
      this.competitionFilters.showGuarantee && result++
      this.competitionFilters.showCapital && result++
      this.competitionFilters.qualificationStart && result++
      this.competitionFilters.qualificationEnd && result++
      return result
    }
  },
  methods: {
    onFilter: function(data) {
      this.$store.dispatch('updateMultipleCompetitionFilter', data)
    },
    selectedStatusFilter: function(filter) {
      return this.competitionStatusFilter === filter
    },
    navigateToCreate: function() {
      this.$router.push('/create-fund')
    },
    onStatusFilterClick: function(value) {
      if (value !== this.competitionStatusFilter) {
        this.$store.dispatch('updateCompetitionFilter', { key: 'status', value })
      }
    },
    pagerChange: function(currentPage) {
      this.$store.dispatch('changeCompetitionPage', currentPage)
    },
    mySortCompare(a, b, key) {
      if (key === 'createdDate' || key === 'modifiedDate') {
        return new Date(a[key]) - new Date(b[key])
      } else {
        return false
      }
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    },
    onFilterChange: function(key, value) {
      this.$store.dispatch('updateCompetitionFilter', { key, value })
    }
  }
}
</script>
<style>
.btn-primary {
  min-width: 0;
}

.btn-group {
  width: 95%;
}
.competition-checkbox > .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #00903c;
  background-color: #00903c;
}

.competition-col-pd {
  padding-left: 15px;
  padding-right: 15px;
}

.competition-frame {
  padding-left: 35px;
  padding-right: 35px;
}
.competition-button {
  width: 90%;
  border-radius: 8px;
  font-weight: 700;
}
.competition-datepicker-input {
  height: 48px !important;
  color: #5b6d75;
  background: #ffffff;
  border: 2px solid #b2bec3 !important;
  box-sizing: border-box;
  border-radius: 4px !important;
}
.competition-datepicker-input > label {
  margin: auto !important;
}

.competition-step-button-row {
  display: flex;
  justify-content: flex-end;
  padding-right: 15px;
}
.competition-step-button {
  width: 320px;
  border: 2px solid #00903c;
  box-sizing: border-box;
  border-radius: 8px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
.competition-step-button:hover {
  border: 2px solid #00903c;
}

.competition-steps legend {
  text-align: left;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  color: #636e72;
  padding-left: 10px;
}

.competition-top-row-position {
  padding-top: 35px;
  padding-left: 25px;
}

.filter-tab {
  margin: auto;
  color: black;
  font-size: 24px;
  line-height: 32px;
  cursor: pointer;
  padding-left: 30px;
  padding-right: 30px;
  margin-right: 50px;
  border: 3px solid transparent;
  transition: border 0.1s ease-in-out;
}

.filter-tab:hover {
  border-bottom: 3px solid #00903c;
}

.filter-link {
  color: #00903c;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
}

.filter-link:hover {
  color: #00903c;
  text-decoration: none;
}

.filter-modal-button {
  width: 175px;
  background-color: #00903c;
  color: white;
  position: absolute;
  right: 2rem;
  bottom: 2rem;
  font-weight: 700;
}

.search-box {
  background: #f2f8fa;
  border-radius: 8px;
}
.selected {
  border-bottom: 3px solid #00903c;
}

input[type='text'],
input[type='number'],
textarea,
select {
  height: 48px !important;
  margin: auto;
  color: #5b6d75;
  background: #ffffff;
  border: 2px solid #b2bec3 !important;
  box-sizing: border-box;
  border-radius: 4px !important;
}
</style>
